import {Mixins, Vue} from 'vue-property-decorator';
import {LoggingUtils} from './mixins';
import ErrorHandler from './errors';

export abstract class LoggingVueApp extends Mixins(LoggingUtils) {
     constructor() {
        super();
        this.initLogging();
    }
}

export abstract class NoServerLoggingVueApp extends Vue {
    constructor() {
        super();
        ErrorHandler.LOG_TO_SERVER = false;
    }
}
